import React,  { useRef } from "react";
import headerImage from "../../assets/header7.jpg";
import ExplanatoryGallery from "../../components/ExplanatoryGallery";
import ExplanatoryGallery2 from "../../components/ExplanatoryGallery2";
import ExplanatoryGallery3 from "../../components/ExplanatoryGallery3";
import final_cnc from '../../assets/final_cnc.mp4';
import w7_1 from '../../assets/w7-1.jpg';
import w7_2 from '../../assets/w7-2.jpg';
import w7_3 from '../../assets/w7-3.jpg';
import w7_29 from '../../assets/w7-29.jpg'
import w7_30 from '../../assets/w7-30.jpg'
import w7_31 from '../../assets/w7-31.jpg'
import w7_32 from '../../assets/w7-32.png'
import w7_33 from '../../assets/w7-33.png'
import w7_34 from '../../assets/w7-34.jpg'
import w7_35 from '../../assets/w7-35.jpg'
import w7_36 from '../../assets/w7-36.png'
import w7_37 from '../../assets/w7-37.jpg'
import w7_38 from '../../assets/w7-38.jpg'
import w7_39 from '../../assets/w7-39.jpg'


const Assignment8 = () => {
  const cnc = useRef(null);
  const modelling = useRef(null);
  const cam = useRef(null);
  const fabrication = useRef(null);
  const assembly = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>7. Week - Computer-Controlled Machining </h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">March 10, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}
      <div className="mt-4 flex space-x-4">
        <button onClick={() => scrollToSection(cnc)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
         CNC
        </button>
        <button onClick={() => scrollToSection(modelling)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
        Modelling
        </button>
        <button onClick={() => scrollToSection(cam)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
          CAM
        </button>
        <button onClick={() => scrollToSection(fabrication)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
        Fabrication
        </button>
        <button onClick={() => scrollToSection(assembly)} className="text-white bg-secondary px-3 py-1 rounded hover:bg-secondary">
        Assembly
        </button>
        </div>
        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6">
        This week we were supposed to make something big. The idea for this week's project came to me while I was preparing for the last New Year's Eve party. I was invited to a house party and was supposed to bring my DJ equipment. Unfortunately, I didn't have a table of the right height that would be easy to transport.
        So the idea was to make a multifunctional table that could be assembled and disassembled, easily stored in the car and quickly set up in the home for projects such as crafts. 
         </p>

        {/* Initial Section*/}
        <div ref={cnc}></div>
        <h2 className="text-3xl font-bold text-left mb-6">General information about CNC Cutting</h2>
    


      <h2 className="text-xl font-bold text-left mb-6">Difference Between Drilling and Milling</h2>

      <img src={w7_1} alt="" className="my-4 mx-auto rounded shadow-md" />

      <p className="text-justify text-gray-700 mb-6">
      <p><strong>Twist drill:</strong> Moves axially to create holes.</p>
      <p><strong>End mill:</strong> Cuts laterally to shape material.</p>

  
      <p className="text-justify mb-6">
        <break></break>
      </p>

      <p className="text-justify mb-6">
        One challenge in milling is that an <>inside corner cannot be perfectly sharp</> when using a round cutting tool. 
        To solve this, <>fillets</> are used. A <strong>fillet</strong> is a design feature that rounds off a corner to accommodate the tool's geometry.
      </p>

      <p className="text-justify mb-4">There are different types of fillets, including:</p>
      <ul className="list-disc list-inside mb-6">
        <li><strong>Sniglet</strong></li>
        <li><strong>T-bone</strong></li>
        <li><strong>Dog bone</strong></li>
      </ul>

      <p className="text-justify mb-6">
        These fillets help ensure that parts fit together properly when CNC machining is used for joinery.
      </p>

      <p className="text-justify mb-4">
        There are different <>toolpaths</> to achieve the <>desired</> result. A <strong>pocket toolpath</strong> cuts on the inside of a closed line or shape, removing all the material within the pocket. 
        A <strong>drill toolpath</strong> makes the CNC operate like a drill press, plunging the end mill <>vertically</> into the material. 
        A <strong>2D figure toolpath</strong> follows a specific shape, such as the <>outer contour</> of a plank, ensuring precise cutting along a predefined path.
      </p>
      <h2 className="text-xl font-bold text-left mb-6">Joint Types</h2>

      <p className="text-justify mb-4">There are various types of joints possible if you want to construct furniture using a CNC router. I will name the most relevant:</p>
      <ul className="list-disc list-inside mb-6">
        <li>Overlap</li>
        <li>Edge-To-Edge</li>
        <li>Edge-To-Edge-To-Edge</li>
        <li>End-To-Face</li>
        <li>End-To-Face-To-Edge</li>
        <li>Through</li>
        <li>Three-Way</li>
        <li>Four-Way Connections</li>
      </ul>

      <p className="text-justify mb-6">
        I decided to use two different types of connections: <>End-To-Face</> and <>End-To-Face-To-Edge</>.
      </p>
  

      <div className="max-w-[800px] mx-auto mt-10">
      <div className="grid grid-cols-2 gap-4">
        <img
          src={w7_2}
          alt="Left Image"
          className="w-full h-[400px] "
        />
        <img
          src={w7_3}
          alt="Right Image"
          className="w-full h-[400px] "
        />
      </div>
    </div>
    <div ref={modelling}></div>
      <h2 className="text-3xl font-bold text-left mb-6">Construction of the 3D-Model</h2>
      <p className="text-justify mb-6">
        As a beginner in <strong>Fusion 360</strong>, one of the key things I learned was how to use 
        <strong> constraints</strong> to define relationships between sketch elements. These constraints help ensure 
        precise and accurate designs. If you’re new to this as well, I highly recommend checking out 
        <a 
          href="https://help.autodesk.com/view/fusion360/ENU/?guid=SKT-CONSTRAINTS" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          this helpful Autodesk guide on constraints
        </a>.
      </p>

      <p className="text-justify mb-6">
        Creating the <>connectors</> was a bit tricky for me at first. As someone still getting 
        familiar with Fusion 360, it took some patience to properly construct the joints. Thankfully, after 
        some trial and error, I was able to make it work!
      </p>

      <p className="text-justify mb-6">
        Before jumping into the design, I consulted my instructor <strong>Lars</strong> to understand potential 
        pitfalls in joint design. He pointed out an important detail: I needed to include a <>parameter </> 
        in my sketch to ensure the <>press-fit connections</> would work properly. I then adjusted this 
        parameter based on the <>group assignment tests</>, making sure the fit was just right.
      </p>

      <p className="text-justify mb-6">
        After designing the <>three different parts</> of my project (since the table legs and the 
        substructure are duplicated), I extruded my sketches and assembled them in <strong>Fusion 360</strong> to 
        check if everything fit together properly.
      </p>

      <p className="text-justify mb-6">
        Luckily, there was only <>one small mistake</>, which was easy to fix. I had accidentally set 
        the <>rectangle for the substructure</> to the <>full width of the table</>, causing 
        the <>joint elements to extend beyond the intended slots</>.
      </p>

      <p className="text-justify mb-6">
        Thanks to <strong>parametric design</strong>, I was able to simply <>subtract the excess measurement</>, 
        and the connectors still fit perfectly into the slots. This was a great reminder of how useful parametric 
        modeling can be – small adjustments can be made <>quickly and efficiently</> without needing to 
        redesign everything from scratch!
      </p>

      You can follow along with my Fusion Design in the following slide gallery.
         <ExplanatoryGallery />
      </p>

        {/* CAM */}
        <div ref={cam}></div>
        <h2 className="text-3xl font-bold text-left mb-6">CAM Process</h2>
        <p className="text-justify mb-6">
        Before moving on to the next big step—the <strong>CAM process and manufacturing</strong>—I had a lot of 
        <> respect (and a bit of fear)</> for what was ahead. Like most people working with 
        <> expensive machines</>, I was nervous about making a mistake in the 
        <> NC program settings</> that could cause problems during milling.
      </p>

      <p className="text-justify mb-6">
        Thankfully, I had <>great support</> from my teammates <strong>Lars and Julian</strong>. 
        They patiently guided me through the <strong>setup process</strong> and the different 
        <> NC programming settings</>, which not only helped me understand the workflow but also gave me 
        <> the confidence to do it on my own</>—at least at this stage. Now, I hope I can 
        <> repeat the process in the future</> to solidify what I’ve learned, or that my 
        <> documentation with screenshots</> will be enough to guide me when I need it again.
      </p>

      <p className="text-justify mb-4">
        Here are some important aspects of <strong>NC program </strong> and the <strong>CAM setup</strong> that I focused on:
      </p>

      <ul className="list-disc list-inside mb-6">
        <li>
          <strong>NC Program Structure:</strong> The final output of this process is an <>NC program </> 
          that tells the CNC machine what to do.
        </li>
        <li>
          <strong>Tool Selection & Importing Libraries:</strong> Choosing the right <>tools</> and 
          importing <>tool libraries</> for the machine is an essential step before starting the cutting process.
        </li>
        <li>
        <strong>Using Different Cutters & Their Purpose:</strong> Understanding the difference between 
<> roughing</> and <> finishing</> tools to get the best results.
          </li>
          <li>
          <strong>Safe Tool Retraction Heights:</strong> Setting up the correct height to safely 
          <> retract the tool</> between cuts, avoiding collisions.
          </li>
          <li>
          <strong>Tabs for Stability:</strong> Using tabs (8mm width, 2.3mm height, 75mm spacing) 
          to keep parts stable during milling.
          </li>
          <li>
          <strong>Material Allowance Before Finishing:</strong> Leaving -0.5mm material in roughing 
          passes before the final <>finishing cut</> to ensure accuracy.
          </li>
          <li><strong>Reducing Vibrations & Machine Chatter:</strong> Adjusting settings to <>minimize vibrations</>, 
          ensuring smoother and more precise cuts.</li>

      </ul>

      <p className="text-justify mb-6">
        You can follow along with my CAM project settings in the following slide gallery.
      </p>
      <ExplanatoryGallery2 />



        {/* Fabrication*/}
        <div ref={fabrication}></div>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <h2 className="text-3xl font-bold text-left mb-6">Fabrication Process </h2>

        <video controls className="my-4 mx-auto rounded shadow-md">
        <source src={final_cnc} type="video/mp4" />
      </video>
        <p className="text-justify text-gray-700 mb-6">
        <div className="max-w-3xl mx-auto mt-10 p-6 bg-gray-100 ">
      <h2 className="text-xl font-semibold mb-4">Safety Check Before Milling</h2>
      <p className="text-justify mb-6">
        In our FabLab in Bottrop, we use the <strong>Versatil 2500 CNC machine</strong>.</p>
      <p className="text-justify mb-4">
        Before starting the milling process, a safety check was conducted to ensure a secure and efficient operation. 
        The following precautions were taken:
      </p>

      <ul className="list-disc list-inside space-y-2 text-gray-700">
        <li>Activated the dust extraction system to minimize airborne particles and maintain a clean workspace.</li>
        <li>Turned on the compressed air to keep the milling area clear of debris.</li>
        <li>Verified the correct positioning of the wood panel, ensuring stability during cutting.</li>
        <li>Checked that the milling cutter was securely placed in the correct holder to prevent misalignment.</li>
        <li>Put on hearing protection to safeguard against noise exposure.</li>
        <li>Kept the remote control within reach for immediate operation control and emergency stops.</li>
      </ul>

      <p className="text-justify mt-4">
        For further details, visit our 
        <a 
          href="https://fabacademy.org/2025/labs/bottrop/Assignments/week07/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          group documentation page
        </a>.
      </p>
    </div>
    <h2 className="text-xl font-semibold mb-4">Milling Process</h2>

    <ExplanatoryGallery3></ExplanatoryGallery3>
        <p className="text-justify mb-6">
        My mental state throughout the milling process went through multiple transformations. 
        At first, I felt <>nervous</> when starting the program, but as I watched the machine work, my mindset became almost <>meditative</>. 
        By the time the milling was nearly complete, I found myself filled with anticipation for the final product.
      </p>

      <p className="text-justify mb-6">
        I couldn't help but wonder: Would the press-fit connections actually work as planned? 
        The thought lingered in my mind as I carefully observed the process. 
        In the end, I was relieved that the CNC program ran smoothly, with no unexpected issues. 
        To my surprise, the milling process even managed to beat the estimated NC program times for several sections!
      </p>

      <p className="text-justify mb-4">After milling, there were still a few finishing touches needed to get the parts ready for assembly:</p>
      <ul className="list-disc list-inside mb-6">
        <li>Removing the elements from the board using a chisel.</li>
        <li>Smoothing and cleaning up the remaining tabs with the table router.</li>
        <li>Post-processing the individual components to refine the final look.</li>
        <li>Cleaning the woodshop, including vacuuming both the machines and the floors.</li>
      </ul>
      <img src={w7_31} alt="" className="my-4 mx-auto rounded shadow-md" />
      <p className="text-justify mb-6">
        With everything prepped and polished, I was now ready to put my design to the test! 
        Would the joints fit as expected? I couldn’t wait to find out.
      </p>
      <img src={w7_29} alt="" className="my-4 mx-auto rounded shadow-md" />

      <p className="text-justify mb-6">
        After cutting all the parts, I transported them home by car for final assembly. 
        This was also an unexpected transport test to see if my design met the requirement of easy portability. 
        Even though I hadn’t specifically considered the interior dimensions of my car’s back seat during the design process, 
        the parts fit perfectly within the available width. 
        This meant I could transport the entire table in a small car without needing to fold down the seats—an essential factor, 
        especially when carrying additional equipment like studio monitor speakers or a DJ controller.
      </p>





      </p>

        {/*Assembly*/}
        <div ref={assembly}></div>
        <h2 className="text-3xl font-bold text-left mb-6">Assembly Process</h2>

        <div className="text-gray-700">
      <p className="text-justify mb-6">
        For assembly, I started with the tabletop, placing it upside down on a carpet to prevent scratches and 
        damage in case any parts didn’t fit perfectly. My first step was to attach the horizontal support beams by 
        pressing their edges into the corresponding slots. Once those were in place, I connected the table legs 
        with the rest of the structure.
      </p>

      <p className="text-justify mb-6">
        The press-fit connections required some force but could initially be assembled without tools. 
        Once the table was fully put together, I flipped it over to check its stability.
      </p>


      <p className="text-justify mb-6">
        During this check, I noticed a 1.5mm gap between the table legs and the upper edge-to-face connectors. 
        To address this, I first tried using a ratchet strap with corner protectors to pull the parts together, 
        but the improvement was minimal.
      </p>
   <img src={w7_30} alt="" className="my-4 mx-auto rounded shadow-md" />
      <p className="text-justify mb-6">
        As a next step, I switched to a rubber mallet and a wooden beam to gently hammer the components into 
        proper alignment. This method worked much better, ensuring a flush and secure fit.
      </p>

      <p className="text-justify mb-6">
        Reflecting on this process, I realized that the additional material offset for joints—currently set at 0.1mm—
        might need a slightly larger value for easier assembly in furniture designs, especially for connections that 
        aren't solely held together by press-fit joints.
      </p>

      <h2 className="text-lg font-semibold mt-8 mb-4">Stability Check</h2>
      <p className="text-justify mb-6">
        With the multifunctional table fully assembled, I took the time to test its stability. The structure proved 
        to be highly resistant to vertical loads, as I was able to put my full body weight on it without any signs 
        of instability. Even stronger forces applied to the long edge were no challenge for the construction.
      </p>

      <p className="text-justify mb-6">
        However, I did notice some horizontal movement when applying side-to-side force. While the table remained 
        upright and stable, it exhibited noticeable lateral sway. To prevent any potential issues, especially in 
        party settings, it would be advisable to position the DJ booth against a wall on one of its shorter sides 
        for additional support.
      </p>

      <h2 className="text-lg font-semibold mt-8 mb-4">Planned Reinforcements</h2>
      <p className="text-justify mb-6">
        To counteract this horizontal movement, I had already ordered four stainless steel tension latches, 
        which were meant to secure the horizontal components together during setup, further improving overall stability. 
        Unfortunately, I accidentally ordered them in the wrong size, meaning I couldn’t install them as planned.
      </p>

      <p className="text-justify mb-6">
        If the stability of the DJ booth decreases over time and no longer meets the required standards, 
        I have another backup solution in mind. I would add one or two additional round wooden dowels (60-80mm 
        in diameter) or connector boards to link the table legs horizontally at the lower section of the structure.
      </p>

      <p className="text-justify mb-6">
        These reinforcements would be secured using a pin inserted through a drilled hole, ensuring that they stay 
        in place while still allowing for easy disassembly when needed. This method would provide extra lateral 
        stability without compromising the table's portability—an important factor for mobile setups.
      </p>
    </div>


        <h2 className="text-3xl font-bold text-left mb-6">Lightning</h2>
        <div className="text-gray-700">


      <p className="text-justify mb-6">
        Since one of the main functions of my multifunctional table is to serve as a mobile DJ booth, 
        LED lighting is an absolute must! To keep the design clean, I decided to place the LED strip 
        inside the compartment under the tabletop, making it invisible from five sides and only accessible from below.
      </p>

      <p className="text-justify mb-6">
        For this setup, I chose an LED strip with the WS2801 chipset, controlled by an ESP32 microcontroller. 
        The biggest advantage of this setup is that I can easily use the 
        <a 
          href="https://kno.wled.ge/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          WLED software
        </a> 
        &nbsp; and the WLED Native app on my smartphone. This allows me to control the LED strip just like any other 
        smart home device—without any programming!
      </p>

      <h2 className="text-lg font-semibold mt-8 mb-4">Installing WLED on the ESP32</h2>
      <p className="text-justify mb-6">
        The easiest way to set up WLED is by using the Web Installer, which works only in the latest versions of 
        Chrome or Edge.
      </p>

      <p className="mb-4">
        🔗 <strong>Installer Link:</strong>  
        <a 
          href="https://install.wled.me/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          install.wled.me
        </a>
      </p>
      <img src={w7_32} alt="" className="my-4 mx-auto rounded shadow-md" />
      <p className="text-justify mb-6">
        The installation process is very straightforward. Once completed, I connected VCC, GND, and Pin 2 of the ESP32 
        to the LED strip according to the instructions on the WLED website.
      </p>

      <p className="text-justify mb-6">
        When wiring the LED strip, make sure to follow the correct orientation! LEDs only work in one direction, 
        and the arrow on the strip indicates the flow direction of the signal.
      </p>

      <h2 className="text-lg font-semibold mt-8 mb-4">Wi-Fi Setup</h2>
      <p className="text-justify mb-6">
        After wiring everything up, I connected the ESP32 to a power bank, and the LED strip immediately lit up in orange – success!
      </p>
      <img src={w7_34} alt="" className="my-4 mx-auto rounded shadow-md" />
      <p className="text-justify mb-6">
        The next step was to configure the Wi-Fi connection. If the ESP32 doesn't detect a known network, 
        it automatically creates its own Access Point called <strong>WLED-AP</strong>.
      </p>

      <ul className="list-none mb-6">
        <li><strong>Wi-Fi Name:</strong> WLED-AP</li>
        <li><strong>Password:</strong> wled1234</li>
      </ul>
      <img src={w7_35} alt="" className="my-4 mx-auto rounded shadow-md" />
      <p className="text-justify mb-6">
        After connecting to this network, a web-based version of the WLED app opened automatically. 
        Under the Config tab, I selected my home Wi-Fi, entered the password, and clicked "Save & Connect."
      </p>

      <p className="text-justify mb-6">
        As soon as the connection was established, the ESP32 disconnected from the Access Point and joined my Wi-Fi network.
      </p>


      <h2 className="text-lg font-semibold mt-8 mb-4">Final Setup</h2>
      <p className="text-justify mb-6">
        Now, the LED strip appeared in the WLED Native app and was fully controllable!
      </p>
      <img src={w7_36} alt="" className="my-4 mx-auto rounded shadow-md" />
      <img src={w7_37} alt="" className="my-4 mx-auto rounded shadow-md" />

      <p className="text-justify mb-6">
        Just like with big-brand smart lighting systems, I can now choose from a huge variety of modes, colors, 
        and effects to match the mood of any event.
      </p>

      <p className="text-justify mb-6">
        With everything now assembled and illuminated, the multifunctional DJ booth is officially complete!
      </p>
    </div>
    <img src={w7_38} alt="" className="my-4 mx-auto rounded shadow-md" />
    <img src={w7_39} alt="" className="my-4 mx-auto rounded shadow-md" />

    <h2 className="text-3xl font-bold text-left mb-6 mt-2">Downloads</h2>
  <p className="text-justify text-gray-700 mt-4">
    You can download my Fusion 360 File here: 

<a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Table_Project_CNC.f3d"
    download
  >
    📎 Download Fusion File
  </a>
  </p>

        </div>



  );
};

export default Assignment8;
